import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('PUT', `${APIV2_URL}/listing/${listingId}/unpublish`);
